import React, { ReactNode, useState } from 'react';

import { SearchResults } from '@gn-audio/jss-core';

import { SearchContext } from './search.context';

interface ISearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<ISearchProviderProps> = ({
  children,
}: ISearchProviderProps) => {
  const [searchResults, setSearchResults] = useState<SearchResults>({ count: 0, items: [] });

  return (
    <SearchContext.Provider value={{ searchResults, setSearchResults }}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;
